import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Function from '../views/Function.vue'
import List from '../views/List.vue'
import Pro from '../views/Pro.vue'
import Show from '../views/Show.vue'
import Zskt from '../views/Zskt.vue'
import ZsktList from '../views/ZsktList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/function',
    name: 'Function',
    component: Function
  },
  {
    path: '/list',
    name: 'List',
    component: List
  },
  {
    path: '/news',
    name: 'News',
    component: Show
  },
  {
    path: '/pro',
    name: 'Pro',
    component: Pro
  },
  {
    path: '/show',
    name: 'Show',
    component: Show
  },
  {
    path: '/zskt',
    name: 'Zskt',
    component: Zskt
  },
  {
    path: '/zsktlist',
    name: 'ZsktList',
    component: ZsktList
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
